<mat-sidenav-container class="shell" [dir]="direction">
  <mat-sidenav
    class="shell-sidenav"
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="sidenavOpened"
    [autoFocus]="isMobile"
    role="navigation"
  >
    <app-sidebar
      [isMobile]="isMobile"
      (navigateItem)="closeSidenavOnMobile()"
    ></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="shell-content">
    <app-header
      [isMobile]="isMobile"
      [sidenavOpened]="sidenavOpened"
      (menuToggle)="toggleSidenav()"
    ></app-header>

    <main class="shell-main">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-right-sidebar></app-right-sidebar>
